import React, { FunctionComponent } from "react";
import { FormSection } from "../../../FormSection";
import {
  ButtonGroup,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Button as MuiButton,
} from "@mui/material";
import { DropdownValue } from "../../../../types/DropdownValue";
import { CustomSelect } from "../../../CustomSelect";
import { mdiMapMarkerRadiusOutline, mdiStoreOutline } from "@mdi/js";
import { Icon } from "@mdi/react";
import { SectionProps } from "../props";
import Search from "@mui/icons-material/Search";
import { FormatListBulleted } from "@mui/icons-material";
import { User } from "../../../../model/User";

type LeadDetailState = {
  newDealerId: number;
  sendEmail: boolean;
  dropdownDealerItems: DropdownValue[];
  handleDealerInfoOpen: () => void;
  handleAddCoverageOpen: () => void;
  onLookForward: () => void;
  onChangeCheckBox: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const AssignedDealer: FunctionComponent<LeadDetailState & SectionProps> =
  (props) => {
    const user = new User();

    const showReassingDealer = !user.HasForbiddenAccess(
      "Can See Reassign Dealer"
    );
    const showDealerInfo = !user.HasForbiddenAccess("Can See Dealer Info");
    const showCoveringDealers = !user.HasForbiddenAccess(
      "Can See Covering Dealers"
    );
    const showForwardLook = !user.HasForbiddenAccess("Can See Forward Look");
    const showEmailDealer = !user.HasForbiddenAccess("Can See Email Dealer");
    const showAssignedDealer =
      showReassingDealer ||
      showDealerInfo ||
      showCoveringDealers ||
      showForwardLook ||
      showEmailDealer;

    const editReassignDealer = !user.HasForbiddenAccess(
      "Can Edit Reassign Dealer"
    );
    const editEmailDealer = !user.HasForbiddenAccess("Can Edit Email Dealer");
    return showAssignedDealer ? (
      <FormSection title="Assigned Dealer" isCollapsible>
        {user.Roles[0].secLevel !== 1 && (
          <Grid item>
            <CustomSelect
              disabled={props.formDisabled || !editReassignDealer}
              MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
              width={360}
              StartIcon={<Icon path={mdiStoreOutline} />}
              label="Reassign to Dealer"
              placeholder="Select a product"
              value={props.newDealerId}
              name="newDealerId"
              onChange={props.onChangeSelect}
            >
              {props.dropdownDealerItems.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.id}>
                    {item.description}
                  </MenuItem>
                );
              })}
            </CustomSelect>
          </Grid>
        )}
        {showEmailDealer && (
          <Grid item>
            <FormControlLabel
              sx={{ mt: 3 }}
              disabled={props.formDisabled || !editEmailDealer}
              control={
                <Checkbox
                  name="sendEmail"
                  value={props.sendEmail}
                  onChange={props.onChangeCheckBox}
                />
              }
              label="Email Dealer"
            />
          </Grid>
        )}
      </FormSection>
    ) : null;
  };

/**
 * <SectionTitle title="Assigned Dealer" />
              <Stack
                direction="row"
                alignItems="end"
                justifyContent="start"
                spacing={4}
                mt={2}
              >
                <Grid
                  container
                  columns={{ xs: 12, sm: 12, md: 12 }}
                  rowSpacing={2}
                >
                  <Stack direction="row" alignItems="center" mt={2}>
                    {user.Roles[0].secLevel !== 1 && showReassingDealer && (
                      <CustomSelect
                        disabled={state.formDisabled || !editReassignDealer}
                        MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
                        width={360}
                        StartIcon={<Icon path={mdiStoreOutline} />}
                        label="Reassign to Dealer"
                        placeholder="Select a product"
                        value={state.newDealerId}
                        name="newDealerId"
                        onChange={onChangeSelect}
                      >
                        {dropDownDealerAccess.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.id}>
                              {item.description}
                            </MenuItem>
                          );
                        })}
                      </CustomSelect>
                    )}
                    {(showDealerInfo ||
                      showCoveringDealers ||
                      showForwardLook) && (
                      <ButtonGroup
                        disableElevation
                        variant="contained"
                        aria-label="Disabled elevation buttons"
                        sx={{ marginTop: 3, marginLeft: 1 }}
                      >
                        {showDealerInfo && (
                          <MuiButton
                            sx={{
                              backgroundColor: "#1BA0E9",
                              height: 35,
                              textTransform: "none",
                              fontFamily: `"Lato", "Roboto", "Helvetica", "Arial"`,
                            }}
                            disabled={!state.newDealerId}
                            onClick={handleDealerInfoOpen}
                          >
                            <Search />
                          </MuiButton>
                        )}
                        {showCoveringDealers && (
                          <MuiButton
                            onClick={handleAddCoverageOpen}
                            aria-haspopup="menu"
                            sx={{ backgroundColor: "#1BA0E9", height: 35 }}
                          >
                            <FormatListBulleted />
                          </MuiButton>
                        )}
                        {showForwardLook && (
                          <MuiButton
                            onClick={onLookForward}
                            aria-haspopup="menu"
                            sx={{ backgroundColor: "#1BA0E9", height: 35 }}
                          >
                            <Icon path={mdiMapMarkerRadiusOutline} />
                          </MuiButton>
                        )}
                      </ButtonGroup>
                    )}
                  </Stack>
                </Grid>
                {showEmailDealer && (
                  <FormControlLabel
                    sx={{ mt: 3 }}
                    disabled={state.formDisabled || !editEmailDealer}
                    control={
                      <Checkbox
                        name="sendEmail"
                        value={state.sendEmail}
                        onChange={onChangeCheckBox}
                      />
                    }
                    label="Email Dealer"
                  />
                )}
              </Stack>
            </>
          )}
 */
